export const genders = [
  {
    text: 'MR',
    value: 'MALE',
  },
  {
    text: 'MRS',
    value: 'FEMALE',
  },
];
